import axios from 'axios';
import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { serviceProviderList, serviceProviderDelete, changeStatus, logOutApi, resendInvitation } from '../../../Context/api';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

const UseProvider = () => {
    const [serviceProviderData, setServiceProviderData] = useState([]);
    const [serviceProvideId, setServiceProvideId] = useState('');
    const [filter, setFilter] = useState({
        provider: '',
        email: '',
        deleted: 'false',
        status: 'true',
        isAssignLoginForProvider: 'true'
    })
    const [count, setCount] = useState('')
    const [page, setPage] = useState(1)
    const PER_PAGE = 10
    const [spinner, setSpinner] = useState(false)
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    let isActive = true;
    const navigate = useNavigate()
    useEffect(() => {
        listServiceProvider()
        setSpinner(true)
    }, [page])

    const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: adminData.deviceId, userId: adminData.userId, type: 'WEBADMIN' }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                localStorage.removeItem('adminData')
                navigate('/')
            }
        })
    }
    const listServiceProvider = () => {
        const data = {
            isDeleted: filter.deleted === 'true',
            isActive: filter.status === 'true',
            isAssignLoginForProvider: filter.isAssignLoginForProvider === 'true',
            searchText: filter.provider,
            searchEmail: filter.email,
            page: page,
            count: PER_PAGE
        }
        axios.post(serviceProviderList(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setServiceProviderData(resp.data)
                setCount(resp.data.totalCount);
                setSpinner(false)
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                setServiceProviderData([])
                if (page > 1) {
                    setPage(page - 1)
                }
                setSpinner(false)

            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const deleteServiceProvider = () => {
        axios.post(serviceProviderDelete(), { id: serviceProvideId, timeZone: timeZone, nowTime: moment(new Date()).format(), }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                listServiceProvider()
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                toast.error(resp.data.message)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
            })
    }
    const statusChange = (item) => {
        setSpinner(true)
        axios.post(changeStatus(), { id: item._id, isAssignLoginForProvider: !item.isAssignLoginForProvider }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                isActive = item.isActive
                listServiceProvider()
                setSpinner(false)
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                toast.error(resp.data.message)
                setSpinner(false)
            }
        })
    }
    const handleChange = (e) => {
        const { name, value } = e.target
        setFilter((pre) => ({
            ...pre,
            [name]: value
        }))
    }
    const invitationResend = () => {
        setSpinner(true)
        axios.post(resendInvitation(), { providerId: serviceProvideId },).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                setSpinner(false)
                listServiceProvider()
            }
            else {
                setSpinner(false)
                toast.error(resp.data.message)

            }
        }).catch(() => {
            toast.error(commonMessage.networkError)
            setSpinner(false)
        })
    };
    return {
        setServiceProviderData,
        deleteServiceProvider,
        setServiceProvideId,
        invitationResend,
        handleChange,
        statusChange,
        setSpinner,
        setFilter,
        navigate,
        setCount,
        setPage,
        listServiceProvider,
        serviceProviderData,
        serviceProvideId,
        PER_PAGE,
        spinner,
        filter,
        count,
        page,

    }
}

export default UseProvider